import { render, staticRenderFns } from "./PlayVideoIcon.vue?vue&type=template&id=6ec55c24"
import script from "./PlayVideoIcon.vue?vue&type=script&lang=js"
export * from "./PlayVideoIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports